function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 5,
  width: 4,
  height: 9,
  rx: 1,
  fill: "#0085FF"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.171 13.085c-1.529 1.733-6.132.578-8.171 0V6.5c.764-1.154 2.736-1.847 3.5-4.446.547-1.86 3.142-1.054 3.142 0s-.764 3.852 0 3.853c.765.002 2.625-.49 3.058 0 .765.865 0 5.444-1.529 7.178z",
  fill: "#0085FF"
});
function SvgThumbupBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgThumbupBlue;